export default __webpack_public_path__ + "static/media/agent.c77cd64a.jpg";